export const CustomizedError = (object: object): Error & object => {
  return Object.assign(new Error(), object);
};
